import React from 'react';
import { VisuallyHidden } from '../utils';

export const renderFormLabel = (
  styledLabel: (label: string) => React.JSX.Element,
  label?: string,
  hideLabel?: boolean
) => {
  if (!label) return null;

  return hideLabel ? <VisuallyHidden> {styledLabel(label)}</VisuallyHidden> : styledLabel(label);
};
